import WidgetView from 'views/dashboard/widgetView'
import template from 'text-loader!templates/dashboard/widget/timeWidget.html'
import dayjs from 'libraries/dayjs'
import _ from 'underscore'

WidgetView.TimeWidget = WidgetView.extend({
  template: template,
  onInitialize: function () {
    _.bindAll(this, 'render');
    this._startInterval();
  },
  onClose: function () {
    this._clearInterval();
  },
  enterEditMode: function () {
    // Constant rerendering is not wanted in edit-mode, and it
    // also causes problems with the overlay.
    this._clearInterval();
  },
  exitEditMode: function () {
    this._startInterval();
  },
  prepareSerializedData: function () {
    return {time: dayjs()};
  },
  _startInterval: function () {
    this.interval = window.setInterval(this.render, 1000);
  },
  _clearInterval: function () {
    window.clearInterval(this.interval);
  }
});

export default WidgetView.TimeWidget;

